import React, { memo } from "react";
import Icon from "../../assets/icons/Icon";
import { validateNumber } from "../../helper/common";

const MarketWatchPriceChangeFontColor = ({ value, isPercentage = false }) => {
  // const modifyVal = !isPercentage ? value : value.replace(/^-/, "").trim();

  // Precompute status once
  const isValidNumber = validateNumber(value);
  const isPositive = isValidNumber > 0;
  const isNegative = isValidNumber < 0;

  return (
    <div
      className={`price-container text-end ${
        isPositive ? "text-success" : isNegative ? "text-danger" : ""
      }`}
    >
      {isPercentage ? (
        <>
          {isPositive ? (
            <Icon name="FaCaretUp" />
          ) : isNegative ? (
            <Icon name="FaCaretDown" />
          ) : null}
          &nbsp;
          {value !== "" && value !== null && value !== undefined
            ? `${value}%`
            : ""}
        </>
      ) : (
        value
      )}
    </div>
  );
};

export default memo(MarketWatchPriceChangeFontColor);
